<template>
  <div class="btn-remove-container">
    <div class="del-confirm" v-if="count">
      <p v-if="!text">คลิกอีกครั้งเพื่อยืนยันการลบ</p>
      <p v-if="text">{{ text }}</p>
    </div>
    <button
      :class="(count) ? 'btn btn-light btn-action btn-confirm' : 'btn btn-light btn-action'"
      :disabled="disabled"
      @click="onDelete()">
      <i class="fas fa-trash-alt" v-if="!iconClass"></i>
      <i :class="iconClass" v-if="iconClass"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: ['confirm', 'text', 'disabled', 'iconClass'],
  data() {
    return {
      count: 0,
    };
  },
  methods: {
    onDelete() {
      if (!this.count) {
        this.count += 1;
        setTimeout(() => {
          this.count = 0;
        }, 1800);
      } else {
        this.$emit('confirm');
        this.count = 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
.btn-remove-container {
  position: relative;
  .del-confirm {
    position: absolute;
    top: -60px;
    left: -54px;
    width: 149px;
    text-align: center;
    background: #dc3545;
    color: #FFF;
    padding: 6px;
    border-radius: 0.25rem;

    p {
      margin: 0;
    }
  }

  .btn-confirm {
    background: $red;
    i {
      color: #FFF;
    }

    &:after, &:before {
      top: -14px;
      left: 20px;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: transparent;
      border-top-color: $red;
      border-width: 10px;
      margin-left: -10px;
    }

    &:before {
      border-color: transparent;
      border-top-color: $red;
      border-width: 16px;
      margin-left: -16px;
    }
  }

  button {
    &:disabled {
      cursor: not-allowed;
    }
  }
}
</style>
